import React, { useState } from 'react';
import { AssistantAnswers, AssistantQuestion } from '../../types/ai.types';

const OTHER = '__other__';

interface AssistantAskProps {
  questions: AssistantQuestion[];
  onDone: (text: string, answers: AssistantAnswers) => void;
}

const AssistantAsk: React.FC<AssistantAskProps> = ({ questions, onDone }) => {
  const [index, setIndex] = useState(0);
  const [picked, setPicked] = useState<AssistantAnswers>({});
  const [other, setOther] = useState('');
  const current = questions[index];
  if (!current) return null;
  const selected = picked[current.id] || '';

  const labelOf = (question: AssistantQuestion, value: string) => {
    const option = question.options.find((item) => item.id === value);
    return option ? option.label : value;
  };

  const finish = (next: AssistantAnswers) => {
    const answers: AssistantAnswers = {};
    const labels: string[] = [];
    questions.forEach((question) => {
      const value = String(next[question.id] || '').trim();
      if (!value) return;
      answers[question.id] = value;
      labels.push(labelOf(question, value));
    });
    if (labels.length) onDone(labels.join(', '), answers);
  };

  const goNext = () => {
    const value = selected === OTHER ? other.trim() : selected;
    const next = { ...picked, [current.id]: value };
    setPicked(next);
    setOther('');
    if (index >= questions.length - 1) {
      finish(next);
      return;
    }
    setIndex(index + 1);
  };

  return (
    <div className="assistant-ask">
      <p className="assistant-ask__kicker">Quelques questions</p>
      <p className="assistant-ask__prompt">{current.prompt}</p>
      <div className="assistant-ask__options" role="radiogroup" aria-label={current.prompt}>
        {current.options.map((option) => (
          <label key={option.id} className={selected === option.id ? 'is-on' : ''}>
            <input
              type="radio"
              name={current.id}
              checked={selected === option.id}
              onChange={() => setPicked((prev) => ({ ...prev, [current.id]: option.id }))}
            />
            <span>{option.label}</span>
          </label>
        ))}
        <label className={selected === OTHER ? 'is-on' : ''}>
          <input
            type="radio"
            name={current.id}
            checked={selected === OTHER}
            onChange={() => setPicked((prev) => ({ ...prev, [current.id]: OTHER }))}
          />
          <span>Autre</span>
        </label>
        {selected === OTHER && (
          <input
            className="assistant-ask__other"
            value={other}
            placeholder="Préciser"
            onChange={(event) => setOther(event.target.value)}
          />
        )}
      </div>
      <div className="assistant-ask__bar">
        <span>{index + 1} / {questions.length}</span>
        <div>
          {index > 0 && (
            <button type="button" onClick={() => setIndex(index - 1)}>Retour</button>
          )}
          <button type="button" onClick={() => {
            const next = { ...picked };
            delete next[current.id];
            setPicked(next);
            setOther('');
            if (index >= questions.length - 1) finish(next);
            else setIndex(index + 1);
          }}
          >
            Passer
          </button>
          <button type="button" className="is-next" disabled={!selected || (selected === OTHER && !other.trim())} onClick={goNext}>
            {index >= questions.length - 1 ? 'Valider' : 'Suivant'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssistantAsk;
